















import { Component, Vue } from 'vue-property-decorator';

import ElementBgIcon from '@/components/elements/ElementBgIcon.vue';

@Component({
  components: { ElementBgIcon },
})
export default class HomeWalkingDemoTrial extends Vue {
  get doctor() {
    return this.$pdc.doctor;
  }

  get lastAcquisitions() {
    return this.doctor!.lastAcquisitions.filter((x: any) => x.patient);
  }

  get lastWalkingAcquisition() {
    return this.lastAcquisitions?.find((x) => x.analysisType === 'podosmart');
  }

  get link() {
    return `/patient/${this.lastWalkingAcquisition?.patient._id}/result/${this.lastWalkingAcquisition?._id}`;
  }

  goTo() {
    // Analytics
    this.$pdc.analytics?.actions.trackSuccess('DemoAnalysis Clicked', {
      type: 'walking',
    });

    this.$router.push(this.link);
  }
}
